<template>
    <div>
        <base-header type="gradient-login_varient" class="pb-2 pb-2 pt-5 pt-md-8">
            
        </base-header>
        
        <div class="container-fluid mt--7">
            <div class="row mt-5">
                <div class="col">
                    <fournisseur-table title="Fournisseurs"></fournisseur-table>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
  import FournisseurTable from './Tables/FournisseurTable'
  export default {
    name: 'tables',
    components: {
      FournisseurTable
    }
  };
</script>
<style></style>
